export const APP_DEBUG=process.env.NODE_ENV=="development"?true:false;
export const APP_API_URL = process.env.NODE_ENV=="development"?"http://192.168.1.239/laparapi/public/api/":"https://lapar.gonow.my/api/";
export const APP_FILE_URL = process.env.NODE_ENV=="development"?"http://192.168.1.239/laparapi/public/":"https://lapar.gonow.my/";
export const APP_STORAGE_URL = process.env.NODE_ENV=="development"?"http://192.168.1.239/laparapi/public/storage/":"https://lapar.gonow.my/storage/";
// export const APP_API_URL = "https://lapar.gonow.my/api/";
// export const APP_FILE_URL = "https://lapar.gonow.my/";
// export const APP_STORAGE_URL ="https://lapar.gonow.my/storage/";

if(!APP_DEBUG){
    console.log('%cWARNING', 'color: #F44336; font-size: 3rem;');
    console.log('%cThis is a browser feature intended for developers.Do NOT copy and paste something here if you do not understand it.', 'color: #EF5350; font-size: 1.5rem;');
}

export const APP_VERSION=4;
export const APP_VERSION_NAME="v2.0.4";